import * as React from "react";
import { IReport2Presenter } from "../../../presenter/report/Report2Presenter";
import Report2ParamBox from "../../components/report/Report2ParamBox";
import { Divider, Typography, Icon } from "antd";
import PDFExportLink from "../../components/app/PDFExportLink";
import ReportPreview from "../../components/app/ReportPreview";
export interface Props {}

export interface State extends IReport2Presenter {}

export default class Report2Page extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      report2PeriodFrom,
      onPeriodFromChange,
      report2PeriodTo,
      onPeriodToChange,
      report2Min,
      onMinChange,
      report2Max,
      onMaxChange,
      report2EvaluationStatus,
      onEvaluationStatusChange,
      getReport2PDF,
      report2,
      getReport2XLSXLink
    } = this.state;

    const { report2Loader } = this.state.loaders;

    return (
      <div className={"report-container"}>
        <Report2ParamBox
          translate={translate}
          periodFrom={report2PeriodFrom}
          onPeriodFromChange={onPeriodFromChange}
          periodTo={report2PeriodTo}
          onPeriodToChange={onPeriodToChange}
          min={report2Min}
          onMinChange={onMinChange}
          max={report2Max}
          onMaxChange={onMaxChange}
          evaluationStatus={report2EvaluationStatus}
          onEvaluationStatusChange={onEvaluationStatusChange}
          getPDFReport={getReport2PDF}
          loading={report2Loader}
        />
        <Divider type={"vertical"} style={{ height: "100%" }} />
        {report2 && (
          <div style={{ width: "75%", paddingLeft: 10 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <Typography.Title style={{ fontSize: 14 }}>
                {translate("reports.review_report")}
              </Typography.Title>
              <div>
                {!this.state.loaders.report2Loader && (
                  <PDFExportLink
                    translate={translate}
                    data={report2}
                    subtitle={translate("reports.report_2")}
                    fileName={`${translate("reports.report_2")}.pdf`}
                    showTitle={false}
                  />
                )}
                <Divider
                  type={"vertical"}
                  style={{ fontSize: 10, height: "100%" }}
                />
                <a
                  key="file-excel"
                  href={getReport2XLSXLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon
                    type="file-excel"
                    theme={"outlined"}
                    style={{ fontSize: 20, color: "#20744B" }}
                  />
                </a>
              </div>
            </div>
            <Divider type={"horizontal"} />
            <ReportPreview
              translate={translate}
              data={report2}
              subtitle={translate("reports.report_2")}
            />
          </div>
        )}
      </div>
    );
  }
}
